import _ from 'root/libs/exaforte/react/lodash';

export const Months = [
    {title: 'januari', short_title: 'jan'},
    {title: 'februari', short_title: 'feb'},
    {title: 'maart', short_title: 'mrt'},
    {title: 'april', short_title: 'apr'},
    {title: 'mei', short_title: 'mei'},
    {title: 'juni', short_title: 'jun'},
    {title: 'juli', short_title: 'jul'},
    {title: 'augustus', short_title: 'aug'},
    {title: 'september', short_title: 'sep'},
    {title: 'oktober', short_title: 'okt'},
    {title: 'november', short_title: 'nov'},
    {title: 'december', short_title: 'dec'},
];

export const Days = [
    'zondag',
    'maandag',
    'dinsdag',
    'woensdag',
    'donderdag',
    'vrijdag',
    'zaterdag'
];

var cache = {};

class CustomDate extends Date {
    static getCustomDateTime(datetime, use_cache) {
        let is_string = typeof datetime === 'string';
        
        if(use_cache && cache[is_string ? _.get_date_format(datetime, true) : datetime] && cache[is_string ? _.get_date_format(datetime, true) : datetime].datetime)
            return cache[is_string ? _.get_date_format(datetime, true) : datetime].datetime;
        
        let date = new CustomDate(is_string ? _.get_date_format(datetime, true) : datetime);
        
        if(is_string && datetime.includes(' '))
        {
            date.setHours(0,0,0,0);
            date.setMinutes(_.time_to_minutes(_.get_time_format(datetime)));
        }
        
        if(use_cache)
        {
            if(!cache[is_string ? _.get_date_format(datetime, true) : datetime])
                cache[is_string ? _.get_date_format(datetime, true) : datetime] = {};

            cache[is_string ? _.get_date_format(datetime, true) : datetime].datetime = date;
        }

        return date;
    };
    
    static getFormat(date, format) {
        if(!cache[date] || !cache[date][format])
        {
            if(!cache[date])
                cache[date] = {};

            cache[date][format] = new CustomDate(date)[format]();
        }
        
        return _.clone(cache[date][format]);
    }
    
    constructor(...args) {
        // Safari fix, want daar moet je een datum YYYY/mm/dd doen ipv YYYY-mm-dd
        if(args && args.length == 1 && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('safari/') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome') == -1 && typeof args[0] === 'string')
            args[0] = args[0].replace(/-/g, '/').replace(/T/g, ' ');
        
        super(...args);
    };

    getFullMonth(){
        return this.getMonth() + 1;
    };
    
    // Returns the four-digit year corresponding to the ISO week of the date.
    getYearWeek() {
        var week = (this.getWeek().toString().length < 2 ? '0' : '') + this.getWeek(); 
         
        return this.getWeekYear() + week;
    };
    
    getLastWeekYearWeek() {
        this.setDate(this.getDate() - 7);
         
        return this.getYearWeek();
    };
    
    getNextWeekYearWeek() {
        this.setDate(this.getDate() + 7);
         
        return this.getYearWeek();
    };
    
    getLastWeekYearMonthDay() {
        this.setDate(this.getDate() - 7);
         
        return this.getYearMonthDay();
    };
    
    // Returns the ISO week number (1-53) of the date. 
    getWeek() {
        var date = new Date(this.getTime());
        
        date.setHours(0, 0, 0, 0);
        
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    };
    
    // Returns the four-digit year corresponding to the ISO week of the date.
    getWeekYear() {
        var date = new Date(this.getTime());
        
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        
        return date.getFullYear();
    };
    
    getYearMonth() {
        var month = (this.getFullMonth().toString().length < 2 ? '0' : '') + this.getFullMonth(); 
        
        return this.getFullYear() + '' + month;
    };
    
    // Returns de date als dd-mm-yyyy
    getDayMonthYear() {
        var day     = (this.getDate().toString().length < 2 ? '0' : '') + this.getDate();
        var month   = (this.getFullMonth().toString().length < 2 ? '0' : '') + this.getFullMonth(); 
        var year    = this.getFullYear();
        
        return day + '-' + month + '-' + year;
    };
    
    getDayMonthYearText(capital, short_notation) {
        var day = (this.getDate().toString().length < 2 ? '0' : '') + this.getDate();
        var year = this.getFullYear();
        
        return day + ' ' + this.getMonthText((capital != undefined ? capital : true), (short_notation != undefined ? short_notation : true)) + ' ' + year;
    };
    
    getDayMonthYearShort() {
        var day     = (this.getDate().toString().length < 2 ? '0' : '') + this.getDate();
        var month   = (this.getFullMonth().toString().length < 2 ? '0' : '') + this.getFullMonth(); 
        var year    = this.getFullYear().toString().substr(-2);
        
        return day + '-' + month + '-' + year;
    };
    
    // Returns de date als dd-mm-yyyy
    getYearMonthDay() {
        var day     = (this.getDate().toString().length < 2 ? '0' : '') + this.getDate();
        var month   = (this.getFullMonth().toString().length < 2 ? '0' : '') + this.getFullMonth(); 
        var year    = this.getFullYear();
        
        return year + '-' + month + '-' + day;
    };
    
    getYesterdayYearMonthDay() {
        this.setDate(this.getDate() - 1);
         
        return this.getYearMonthDay();
    };
    
    getTomorrowYearMonthDay() {
        this.setDate(this.getDate() + 1);
         
        return this.getYearMonthDay();
    };
    
    getDateTime(reverse)
    {
        if(!reverse)
            return this.getDayMonthYear() + ' ' + this.getTimeText(true);
    
        return this.getYearMonthDay() + ' ' + this.getTimeText(true);
    };
    
    getMonday()
    {
        var d       = new CustomDate(this);
        var day     = d.getDay()
        var diff    = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
        
        return new CustomDate(d.setDate(diff));
    };
    
    getSunday()
    {
        var d       = new CustomDate(this);
        var day     = d.getDay();
        var diff    = d.getDate() - day + (day == 0 ? -6:1) + 6;
        
        return new CustomDate(d.setDate(diff));
    };
    
    getFriday()
    {
        var d       = new CustomDate(this);
        var day     = d.getDay();
        var diff    = d.getDate() - day + (day == 0 ? -6:1) + 4;
        
        return new CustomDate(d.setDate(diff));
    };
    
    getSaturday()
    {
        var d       = new CustomDate(this);
        var day     = d.getDay();
        var diff    = d.getDate() - day + (day == 0 ? -6:1) + 5;
        
        return new CustomDate(d.setDate(diff));
    };
    
    getDayNumber()
    {
        let day = (this.getDay() - 1);
        
        if(day < 0)
            day = 6;
        
        return day;
    };
    
    getYesterdayDayNumber() {
        this.setDate(this.getDate() - 1);
         
        return this.getDayNumber();
    };
    
    getTomorrowDayNumber() {
        this.setDate(this.getDate() + 1);
         
        return this.getDayNumber();
    };
    
    getDayText(capital, short_notation)
    {
        var value = '';
        
        if(short_notation === true)
            value = Days[this.getDay()].substr(0, 2);
        else
            value = Days[this.getDay()];
        
        if(capital === true)
            value = value.charAt(0).toUpperCase() + value.slice(1);
        
        return value;
    };
    
    getMonthText(capital, short_notation)
    {
        var value = '';
        
        if(short_notation === true)
            value = Months[this.getMonth()].short_title;
        else
            value = Months[this.getMonth()].title;
        
        if(capital === true)
            value = value.charAt(0).toUpperCase() + value.slice(1);
        
        return value;
    };
    
    getDayMonthYearTime()
    {
        return this.getDateTime();
    };
    
    getTimeText(displaySeconds)
    {
        var hours   = this.getHours();
        var minutes = this.getMinutes();
        var seconds = this.getSeconds();
        
        if(hours < 10)
            hours = '0' + hours;
        
        if(minutes < 10)
            minutes = '0' + minutes;
        
        if(seconds < 10)
            seconds = '0' + seconds;
        
        return hours + ':' + minutes + (displaySeconds === true ? ':' + seconds : '');
    };
    
    getStartOfWeek(){
        var cur_date    = new CustomDate(this.getTime());
        var day         = cur_date.getDay();
        var diff        = cur_date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    
        return new CustomDate(cur_date.setDate(diff));
    };
    
    addWeeks(amount)
    {
        this.setDate(this.getDate() + (7 * amount));
        
        return this;
    };

    getDiff(settings)
    {
        settings = {...{type: 'minutes'}, ...settings};

        if(settings.type == 'minutes')
            return (new CustomDate(settings.date_time) - this)/60000;

        if(settings.type == 'hours')
            return (new CustomDate(settings.date_time) - this)/3600000;
        
        if(settings.type == 'days')
            return (new CustomDate(settings.date_time) - this)/(3600000) * 24;

        return 0;
    };
    
    getDayOfYear()
    {
        let dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        let y = this.getFullYear();
        let m = this.getMonth();
        let d = this.getDate();
        let dayOfYear = dayCount[m] + d;
        
        // leap year en later dan feb
        if(m > 1 && y % 4 == 0)
            dayOfYear++;
        
        return dayOfYear;
    };
}

export default CustomDate;